<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <h1 class="title-default">Configurações</h1>
        <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Configurações</span>! Aqui você encontra as configurações gerais internas da sua empresa.</p>
        
        <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
    </div>
</div>